<template>
  <div class="mt-12 flex flex-col gap-y-2">
    <div class="flex items-center justify-end gap-x-2">
      <TooltipWrapper>
        <template #trigger>
          <button
            class="btn-secondary-color-xs flex shrink-0 gap-x-1.5 whitespace-nowrap"
            data-testid="reviews-reply-edit"
            :disabled="!canReply"
            @click="$emit('edit-reply')"
          >
            <PencilIcon class="lucide-icon-s" />
            {{ t('Reviews.reviewReply.editButtonText') }}
          </button>
        </template>
        <template v-if="!canReply && disabledHint" #content>
          <div class="max-w-xs" v-html="disabledHint" />
        </template>
      </TooltipWrapper>
      <button
        class="btn-secondary-color-xs flex shrink-0 gap-x-1.5 whitespace-nowrap"
        data-testid="reviews-reply-delete"
        @click="$emit('delete-reply')"
      >
        <Trash2Icon class="lucide-icon-s" />
        {{ t('Reviews.reviewReply.deleteButtonText') }}
      </button>
    </div>
    <div class="bg-surface-elevation-2 p-4" data-testid="text-review-quotes-reply">
      <div class="pb-1 text-body-m-bold">
        <span v-if="reviewReply?.personalized">{{ t('Reviews.reviewReply.sectionTitleWithAuthor', { authorName, entityTitle }) }}</span>
        <span v-else>{{ t('Reviews.reviewReply.sectionTitle', { entityTitle }) }}</span>
      </div>
      <MarkdownContent :md="reviewReply?.reply || ''" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { MarkdownContent, TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { PencilIcon, Trash2Icon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { ReviewReplyData } from './types'

const props = defineProps<{
  entityTitle: string
  canReply: boolean
  disabledHint?: string
  reviewReply: ReviewReplyData
}>()

defineEmits(['edit-reply', 'delete-reply'])

const authorName = computed(() => props.reviewReply?.senderName?.split(' ')[0] || null)

const { t } = useI18n()
</script>
